import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toaster } from './shared/ui/toaster';
import { ConfirmHost } from './shared/ui/confirm-host';
import { ThemeService } from './core/theme/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toaster, ConfirmHost],
  template: `
    <router-outlet />
    <app-toaster />
    <app-confirm-host />
  `,
})
export class App {
  // Avviato subito, non al primo pulsante del tema: è lui che segue il sistema operativo
  // finché l'utente non sceglie.
  private readonly theme = inject(ThemeService);
}
